import React, { useEffect, useState } from "react";
import "./Courses.css";
import courseImg from "../../../../assets/images/Courses/course.jpg";
import { Link } from "react-router-dom";
import { Skeleton } from "@mui/material";
import { useTranslation } from "react-i18next";
import OwlCarousel from "react-owl-carousel2";
import "./Owl.css"; //Allows for server-side rendering.

function Course2({ allcourse, course }) {
  const { t } = useTranslation();
  const contentWrapper = React.useRef(null);
  const [lang, setlang] = useState(
    localStorage.getItem("language")
      ? localStorage.getItem("language") === "en"
      : true
  );
  const [filtered, setfiltered] = useState(allcourse);
  const [modaldata, setmodaldata] = useState({});
  const [loopvalue, setloopvalue] = useState(false);
  const [center, setcenter] = useState(false);
  const [autoplay, setautoplay] = useState(true);

  useEffect(() => {
    const keyToFilter = "cd_course_category_id";
    const valueToFilter = course;
    const filteredData = allcourse.filter(
      (item) => item[keyToFilter] === valueToFilter
    );
    if (valueToFilter == "all") {
      setfiltered(allcourse);
      setautoplay(true);
    } else {
      setfiltered(filteredData);
      setautoplay(false);
    }

    if (filteredData.length) {
      if (filteredData.length < 2) {
        setcenter(true);
      } else {
        setcenter(false);
      }
    }
  }, [course, allcourse]);

  const options = {
    items: 3,
    startPosition: 0,
    nav: true,
    loop: loopvalue,
    center: center,
    rewind: true,
    autoplay: autoplay,
    autoplayTimeout: 2000,
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 1,
      },
      800: {
        items: 2,
      },
      1280: {
        items: 3,
      },
      1600: {
        items: 4,
      },
    },
  };

  return (
    <>
      <div className="courseMain" id="courseMain2">
        <div className="owl-div">
          <OwlCarousel options={options} navcontainer={".owl-nav"}>
            {filtered.length ? (
              filtered.map((a, index) => (
                <div key={a.cd_id} className="carousel-box-2">
                  <div className="card">
                    <div className="card-img">
                      <img
                        src={
                          a.cd_img
                            ? `https://m2elearning.com/${a.cd_img}`
                            : courseImg
                        }
                        className="card-img-top"
                        alt={`${a.cd_course_name}`}
                      />
                    </div>
                    <div className="card-body">
                      <h5 className="card-title">{a.cd_course_name}</h5>
                      <p className="card-text">
                        {lang
                          ? a.cd_short_description.slice(0, 90)
                          : a.cd_spanish_course_name
                          ? a.cd_spanish_course_name.slice(0, 90)
                          : ""}{" "}
                        ...
                      </p>
                      <button
                        type="button"
                        className="btn btn-primary"
                        id="btn-course-2"
                        data-bs-toggle="modal"
                        data-bs-target="#exampleModal"
                        onClick={() => {
                          if (lang) {
                            setmodaldata({
                              ...modaldata,
                              cd_course_name: a.cd_course_name,
                              cd_short_description: a.Description
                                ? a.Description
                                : a.cd_short_description,
                              cd_fee: a.fd_TotalFees,
                              cd_duration: a.cd_duration,
                            });
                          } else {
                            setmodaldata({
                              ...modaldata,
                              cd_course_name: a.cd_course_name,
                              cd_short_description: a.cd_long_description
                              ? a.cd_long_description
                              : a.cd_short_description,
                              cd_fee: a.fd_TotalFees,
                              cd_duration: a.cd_duration,
                            });
                          }
                          setautoplay(false);
                        }}
                      >
                        {t("View Details")}
                      </button>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <>
                <Skeleton
                  variant="rectangular"
                  width={`100%`}
                  style={{ margin: "auto" }}
                  height={60}
                />
              </>
            )}
          </OwlCarousel>
        </div>
      </div>

      <div
        className="modal fade"
        id="exampleModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h2 className="modal-title fs-5" id="exampleModalLabel">
                {modaldata.cd_course_name}
              </h2>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  if (course == "all") {
                    setautoplay(true);
                  } else {
                    setautoplay(false);
                  }
                }}
              ></button>
            </div>
            {/* <div >{modaldata.cd_short_description}</div> */}
            <div className="modal-body" dangerouslySetInnerHTML={{ __html:modaldata.cd_short_description}}/>
            <hr />
            <div className="row">
              <div className="col-5">
                <div className="row">
                  <div className="col" id="model-btn">
                    <span
                      className="badge bg-secondary"
                      style={{
                        padding: "10px",
                        margin: "10px",
                        width: "130px",
                      }}
                    >
                      Duration :{" "}
                      {modaldata.cd_duration ? modaldata.cd_duration : ""}
                    </span>
                  </div>
                  <div className="col" id="model-btn">
                    {" "}
                    <span
                      className="badge bg-secondary"
                      style={{
                        padding: "10px",
                        margin: "10px",
                        width: "130px",
                      }}
                    >
                      Fee : ₹{modaldata.cd_fee ? modaldata.cd_fee : ""}
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-7">
                <Link
                  to="https://m2elearning.com/front/signup"
                  target="_blank"
                  className="btn btn-primary  model-btn"
                >
                  {t("Start Learning")}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Course2;
